import { Stack } from "@/Components/v2/atoms/Stack";

import { SatCurveLegendCard, SatCurveLegendCardData } from "../LegendCard/SatCurveLegendCard";

interface LegendProps {
  legends: SatCurveLegendCardData[];
}

export const SatCurveLegendCards: React.FC<LegendProps> = ({ legends }) => {
  return (
    <Stack direction="row" spacing={2} justifyContent="space-between" paddingX={4} paddingY={2}>
      {legends.map((legend) => (
        <SatCurveLegendCard key={legend.key} legend={legend} />
      ))}
    </Stack>
  );
};
